import React, {useState} from 'react';

import ErrorMessage from './ErrorMessage';

type InputProps = {
  id?: string;
  type?: string;
  value?: string | number;
  placeholder?: string;
  className?: string;
  errorMessage?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event?: React.FocusEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  childrenLocated?: 'start' | 'end';
  disabled?: boolean;
  maxLength?: number;
  min?: string;
  children?: React.ReactNode;
};

export const makeBorderClass = (errorMessage?: string, showFocus?: boolean) =>
  `rounded-large border-2 bg-white focus:outline-none disabled:opacity-75 ${
    !errorMessage
      ? showFocus
        ? 'border-turquoise'
        : 'border-skyblue focus:border-turquoise'
      : 'border-brink-pink bg-pink'
  }`;

const Input = ({
  type = 'text',
  className,
  errorMessage,
  children,
  childrenLocated = 'end',
  disabled,
  value,
  ...props
}: InputProps) => {
  const [showFocus, setShowFocus] = useState(false);

  if (children) {
    return (
      <>
        <div
          className={`flex justify-between items-center w-full h-12
            ${makeBorderClass(errorMessage, showFocus)}
            ${className || ''}
            ${disabled ? 'opacity-75' : ''}
          `}
        >
          {childrenLocated === 'start' && children}
          <input
            type={type}
            className="focus:outline-none p-4 px-4 py-2 w-full rounded-large bg-white"
            onFocus={() => setShowFocus(true)}
            onBlur={() => setShowFocus(false)}
            disabled={disabled}
            value={value || ''}
            {...props}
          />
          {childrenLocated === 'end' && children}
        </div>
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </>
    );
  }

  return (
    <>
      <input
        type={type}
        value={value || ''}
        className={`w-full h-12 px-4 py-2 
        ${makeBorderClass(errorMessage, showFocus)}
        ${className || ''}`}
        disabled={disabled}
        {...props}
      />
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </>
  );
};

export default Input;
